export enum OrganizationRole {
  Admin = "Organization Admin",
  User = "Organization User"
}
